import { client, useConfig, useElementData } from '@sigmacomputing/plugin'
import { useEffect } from 'react'
import { themeOptions, themes, formatTypes } from '../utilities'
import '../data-viz/components/Comparison'
  
export default function App() {

    useEffect(() => {
        client.config.configureEditorPanel([
            {
                name: "source",
                type: "element",
            },
            {
                name: "value1",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "value2",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "label1",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "label2",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'format',
                type: 'dropdown',
                values: formatTypes
            },
            {
                name: 'theme',
                type: 'dropdown',
                values: themeOptions
            },
            {
                name: 'title',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            },
            {
                name: 'helpText',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            }
        ])
    }, [])
        
    const config = useConfig()
    const sigmaData = useElementData(config.source)

    const { value1, value2, label1, label2, format, theme, title, helpText } = config
    const val1 = (Object.keys(sigmaData).length && value1) ? sigmaData[value1][0] : null
    const val2 = (Object.keys(sigmaData).length && value2) ? sigmaData[value2][0] : null
    const lab1 = (Object.keys(sigmaData).length && label1) ? sigmaData[label1][0] : null
    const lab2 = (Object.keys(sigmaData).length && label2) ? sigmaData[label2][0] : null

    const valuesArr = [val1, val2]
    const labelsArr = [lab1, lab2]

    return (
        <>
        <zero-comparison
            data-fill={themes[theme]?.default}
            data-fill2={themes[theme]?.dark}
            data-bg={themes[theme]?.light}
            data-heading={title}
            data-format={format}
            data-values={valuesArr.join(',')}
            data-labels={labelsArr.join(',')}
            data-help={helpText}></zero-comparison>
        </>
    )
}
